<template>
<app-layout
    :is-logged-in="isLoggedIn"
    :login-url="loginUrl"
>
    <section class="welcome-main">
        <div class="columns is-gapless is-relative">
            <div class="column is-half welcome-column-top">
                <div
                    class="bg-image--cover bg-image--center bg-image-welcome"
                    :style="{ backgroundImage: `url(${backgroundImage})` }"
                >
                </div>
            </div>

            <div class="column is-half">
                <section class="hero is-fullheight welcome-hero">
                    <div class="hero-body p-0">
                        <div class="container welcome__message">
                            <img
                                v-if="logo"
                                class="welcome__logo mbr-4"
                                :src="logo"
                            >
                            <h3
                                v-else-if="brandName && name && brandName !== name"
                                class="title is-size-3 is-uppercase mbr-4"
                            >
                                {{ name }} by {{ brandName }}
                            </h3>
                            <h3
                                v-else-if="brandName"
                                class="title is-size-3 is-uppercase mbr-4"
                            >
                                {{ brandName }}
                            </h3>
                            <h1
                                v-if="headline"
                                class="title welcome-brand-title"
                            >
                                {{ headline }}
                            </h1>
                            <div
                                v-if="description"
                                class="pl-6 pr-6 mbr-4 welcome-description"
                            >
                                <title-text :text="description" />
                            </div>

                            <a
                                v-if="isRecruitmentOn"
                                class="button is-primary welcome-action-btn"
                                :href="!isLoggedIn ? loginUrl : `/getStarted?handle=${handle}`"
                            >Get Started</a>
                            <p v-else>
                                This brand is not currently recruiting
                            </p>

                            <div
                                v-if="pointOfContact"
                                data-test-point-of-contact
                            >
                                <p v-if="pointOfContact.name">
                                    For more information, contact<br>
                                    {{ pointOfContact.name }} at
                                    <a :href="`mailto:${pointOfContact.email}`">
                                        {{ pointOfContact.email }}
                                    </a>
                                </p>
                                <p v-else>
                                    For more information, contact
                                    <a :href="`mailto:${pointOfContact.email}`">
                                        {{ pointOfContact.email }}
                                    </a>
                                </p>
                            </div>

                            <p
                                v-if="!isLoggedIn"
                                class="is-hidden-tablet pt-4"
                            >
                                Already have an account? <a :href="loginUrl">Log in.</a>
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </section>
</app-layout>
</template>

<script>
import AppLayout from '@/layouts/AppLayout.vue';
import TitleText from '@/components/TitleText.vue';

export default {
    components: {
        AppLayout,
        'title-text': TitleText
    },
    data() {
        return {
            backgroundImage: window.SAILS_LOCALS?.backgroundImage,
            brandName: window.SAILS_LOCALS?.brandName,
            description: window.SAILS_LOCALS?.description,
            handle: window.SAILS_LOCALS?.handle,
            headline: window.SAILS_LOCALS?.headline,
            loginUrl: window.SAILS_LOCALS?.loginUrl,
            logo: window.SAILS_LOCALS?.logo,
            name: window.SAILS_LOCALS?.name,
            userMeta: window.SAILS_LOCALS?.userMeta,
            isRecruitmentOn: window.SAILS_LOCALS?.isRecruitmentOn ?? false,
            isBrandProfileOn: window.SAILS_LOCALS?.isBrandProfileOn ?? false
        };
    },
    computed: {
        isLoggedIn() {
            return !!this.userMeta;
        },
        /**
         * Point of Contact Information (name and email)
         * Grabs point of contact name and email from the document (populated in the BE)
         * If email is not defined, null will be returned
         * If only an email is defined, name will be null (name comes as an empty string from the BE in this case)
         * @returns {?Object}
         */
        pointOfContact() {
            if (window.SAILS_LOCALS) {
                const { pointOfContact, pointOfContactParts } = window.SAILS_LOCALS;
                if (pointOfContactParts) {
                    return {
                        name: pointOfContact ? pointOfContact.trim() : null,
                        email: pointOfContactParts.join('@')
                    };
                }
            }
            return null;
        }
    }
};
</script>

<style lang="scss" scoped>
.welcome__message {
    flex-grow: 1;
    flex-shrink: 1;
    flex-direction: column;
    display: flex;
    align-items: center;

    .button.is-primary.welcome-action-btn {
        margin-bottom: 2rem;
    }
}
.bg-image-welcome {
    width: initial;
    height: 100%;
    margin: 0;

    @media (max-width: 768px) {
        width: 100%;
        height: 300px;
    }
}
</style>
